<template>
    <div class="p-b-lg foot-fix pos-r">

        <!-- Parts Details Modal -->
        <div class="modal fade in" id="parts-details-modal" tabindex="-1" role="dialog">
            <template v-if="partDetails.show">
                <partdetails-modal :id="partDetails.id" :variant-id="partDetails.variantId"></partdetails-modal>
            </template>
        </div>
        <!-- Parts Details Modal -->

        <div class="bg-black" id="bg-steps">
            <div class="header">
                <div class="container">
                    <div class="row">
                        <div class="mobile-only-menu">
                            <a class="mobile-menu" href="/">
                                <img class="img-responsive copyright-logo" src="/assets/logo-bld.png" alt="Logo white">
                            </a>
                            </div>
                        <div class="overview-buy" style="display: none;">
                                <a class="overview" href="#" style="display: none; float: none;">OVERVIEW</a>
                        </div>
                        <div class="share-save" style="opacity: 0; display: inline-block;">
                            <a class="save" href="#">SAVE</a>
                            <a class="share" href="#">SHARE</a>
                        </div>
                        <div class="overview-buy with-checkout pull-right" style="display: none;">
                            <div class="affirm pull-left">
                                <div id="wrapLearnMore" style="display: block;">
                                    <a id="learn-more" style="visibility: visible;">PAY AS LOW AS $86 /MONTH
                                        <div class="affirm-text">FINANCE YOUR PURCHASE THROUGH
                                            <span class="affirm-logo"></span>
                                        </div>
                                    </a>
                                </div>
                            </div>
                            <a class="buy-me2" style="display: none;">CHECKOUT</a>
                            <div class="price">$974.91</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container nzxtcustom2">
                <!-- step-1-games -->
                <div class="row">
                    <div class="games-selection">
                        <div class="six-cols col-xs-12 p-y-md">
                            <div class="container">
                                <template v-if="games.length">
                                    <template v-for="list in games">
                                        <div class="row m-y">
                                            <template v-for="game in list">
                                                <div
                                                    class="game-cover pull-left pos-r text-center"
                                                    :class="'cover_' + game.id">
                                                    <a
                                                        data-html="true"
                                                        data-toggle="tooltip"
                                                        data-placement="bottom"
                                                        :data-original-title="game.name"
                                                        :title="game.name"
                                                        :class="getImageClass(game, 'v-game',
                                                        'disabled-link v-game')">
                                                        <img
                                                            @click="addSelectedGame(game), processClick($event)"
                                                            :src="'/images/april-fools/' + game.image_url"
                                                            :data-ref="game.id"
                                                            :class="getImageClass(game, 'game_no_selected', 'not-rs game_no_selected')"
                                                            alt="">
                                                    </a>
                                                </div>
                                            </template>
                                        </div>
                                    </template>
                                </template>
                                <template v-else>
                                    <div class="row">
                                        <div class="col-md-12 loading-games">
                                            <p>LOADING GAMES</p>
                                        </div>
                                    </div>
                                </template>
                                <!-- selection next step btn and warning -->
                            </div>
                        </div>
                        <div class="container">
                            <!-- 1080/1440 switchery-sendgames -->
                            <div class="row">
                                <!-- switchery -->
                                <div class="col-xs-12 col-sm-3">
                                    <div class="resolution-switch">
                                        <span
                                            :class="[resolutionFilter == '1080' ? 'on' : 'off']">
                                            1080
                                        </span>
                                        <input
                                            @change="toggleChange"
                                            type="checkbox"
                                            id="toggle-resolution"
                                            :value="resolutionFilter"
                                            class="js-switch" />
                                        <span
                                            :class="[resolutionFilter == '1440' ? 'on' : 'off']">
                                            1440
                                        </span>
                                    </div>
                                </div>
                                <!-- /.switchery -->
                                <!-- send-games -->
                                <div class="col-xs-12 col-sm-6 text-center">
                                  <div class="send-games">
                                    <!-- onclick should trigger input -->
                                    <h3
                                        class="text-green m-a-0 pointer"
                                        v-show="gameSearchForm.showQuestion"
                                        @click="gameSearchForm.showInput = true,
                                                gameSearchForm.showThanks = false,
                                                gameSearchForm.showQuestion = false">
                                        CAN'T FIND A GAME YOU WERE LOOKING FOR?
                                    </h3>
                                    <!-- input-group for send games -->
                                    <div class="input-group" v-show="gameSearchForm.showInput">
                                      <input
                                        type="text"
                                        v-model="gameSuggestion"
                                        placeholder="INSERT GAME NAME HERE"
                                        class="form-control line-field">
                                      <span class="input-group-btn m-l-fix" >
                                        <button
                                            :disabled="!gameSuggestion"
                                            @click="sendGameSuggestion()"
                                            class="btn btn-green btn-outline">
                                            SEND
                                        </button>
                                      </span>
                                    </div>
                                    <!-- After submit, display message -->
                                    <h3
                                        class="sub-mss text-white"
                                        @click="gameSearchForm.showThanks = false,
                                                gameSearchForm.showQuestion = true"
                                        v-show="gameSearchForm.showThanks">
                                        THANKS!
                                    </h3>
                                  </div>
                                </div>
                                <!-- /.send-games -->
                                <div class="col-xs-12 col-sm-3">
                                <div class="select-warning m-t-md m-b-lg game-submit">
                                    <!-- next step btn -->
                                    <span class="fools-link" v-show="selectedGames.length > 0 && selectedGames.length <= gameLimit">
                                        <a href="/BLDA#estimate" class="btn btn-block btn-green btn-outline" @click.prevent="foolsModal()">
                                            PICK YOUR PRICE
                                        </a>
                                    </span>
                                    <div class="link2" v-show="selectedGames.length > gameLimit">
                                        <a class="too-many">
                                            <div class="text">OOPS, {{selectedGames.length - gameLimit}}
                                                TOO MANY
                                            </div>
                                        </a>
                                    </div>
                                </div>
                                </div>
                                <!-- /.nextstep-and-warning -->
                            </div>
                            <!-- /.1080/1440 switchery-sendgames -->
                        </div>
                        <div class="clearfix"></div>
                    </div>
                    <!-- select-intro -->
                    <div class="select-intro intro2" style="display:none;">
                        <div class="select-content">
                            <div class="title">
                                <h1 class="text-center text-cgrey">SELECT YOUR GAMES</h1>
                            </div>
                        </div>
                    </div>
                    <!-- /.select-intro -->
                </div>
            </div>
            <!-- /.step-1-games -->
        </div>
        <!-- BLD-OVERLAYS -->
        <div class="loading" style="display: none;">
            <p class="text-center">CALCULATING...</p>
        </div>
        <div class="share-overlay text-center" style="display: none;">
          <a class="close-overlay close  text-white text-light" href="#" rel="share-overlay">
              <span aria-hidden="true">X</span>
          </a>
            <div class="panel-user" style="display: block;">
                <h2 class="text-center">SHARE</h2>
                <div class="row">
                    <div class="col-md-12">
                        <div class="text">
                          <p>
                            USE THE LINK BELOW TO SHARE YOUR BUILD
                          </p>
                        </div>
                        <div class="link m-b"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="save-overlay text-center" style="display: none;">
            <a class="close-overlay close text-white text-light" href="#" rel="save-overlay">
                  <span aria-hidden="true">X</span>
            </a>
            <div class="panel-user" style="display: block;">
                <h2 class="text-center">SHARE YOUR BUILD</h2>
                <div class="row">
                    <div class="col-md-12">
                        <div class="text">CLICK THE LINK BELOW TO SHARE</div>
                        <div class="link m-b"></div>
                        <div class="or">OR</div>
                        <div class="see">
                            <a @click="goToSavedBuilds()">SEE ALL YOUR SAVED BUILDS</a>
                            <div class="breadcrumb-build">BUILDS &gt; Saved</div>
                        </div>
                        <div class="col-md-12 social-icons m-t">
                            <a href="#" id="sharenzxt-twitter" target="_blank">
                                <i class="fa fa-twitter"></i>
                            </a>
                            <a href="#" id="sharenzxt-facebook" target="_blank">
                                <i class="fa fa-facebook-square"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="share-overlay-list text-center" style="display: none;">
            <a class="close-overlay text-white text-light" href="#" rel="share-overlay-list">
              <span aria-hidden="true">X</span>
            </a>
            <h2 class="text-center">SHARE YOUR BUILD</h2>
            <div class="row">
                <div class="col-md-12">
                    <div class="link"></div>
                </div>
            </div>
        </div>
        <div class="message-overlay text-center" style="display: none;">
            <a class="close-overlay" href="#" rel="message-overlay">
                <img src="/assets/close-overlay.png" alt="Close overlay">
            </a>
            <div class="panel-text"></div>
        </div>
        <div class="exit-survey-overlay" style="display:none;">
            <a class="close-overlay" href="#" rel="exit-survey-overlay">
                <img src="/assets/close-overlay.png" alt="Close overlay">
            </a>
            <h2 class="text-center">How can we improve your experience?</h2>
            <form id="exit-survey-form" action="/exit-survey" accept-charset="UTF-8" method="post">
                <input name="utf8" type="hidden" value="✓">
                <input type="hidden" name="authenticity_token" value="+vbw4qKPk+T1Um0DAecIY1edNjTU2N/2nuRaZjEls+SsT6lNCIq2dcm8fprNLBK5aFHgOCA4r7pzmexdnBTj1g==">
                <div class="field">
                    <input
                        type="radio"
                        name="reason" id="reason_Better_pricing" value="Better pricing">
                    <label value="Better pricing" for="reason_Better_pricing">Better pricing</label>
                </div>
                <div class="field">
                    <input
                        type="radio"
                        name="reason"
                        id="reason_More_parts_to_choose_from"
                        value="More parts to choose from">
                    <label
                        value="More parts to choose from"
                        for="reason_More_parts_to_choose_from">More parts to choose from
                    </label>
                </div>
                <div class="field">
                    <input
                        type="radio"
                        name="reason"
                        id="reason_More_well_known__Brand_awareness"
                        value="More well known (Brand awareness)">
                    <label
                        value="More well known (Brand awareness)"
                        for="reason_More_well_known__Brand_awareness">More well known (Brand awareness)
                    </label>
                </div>
                <div class="field">
                    <input
                        type="radio"
                        name="reason" id="reason_Make_it_easier_to_use" value="Make it easier to use">
                    <label
                        value="Make it easier to use"
                        for="reason_Make_it_easier_to_use">Make it easier to use
                    </label>
                </div>
                <div class="field">
                    <input
                        type="radio"
                        name="reason" id="reason_I_like_it" value="I like it!">
                    <label value="I like it!" for="reason_I_like_it">I like it!</label>
                </div>
                <div class="field">
                    <input
                        type="radio"
                        name="reason" id="reason_Other" value="Other">
                    <label value="Other" for="Other">Other</label>
                    <input type="hidden" name="Details" id="Details">
                </div>
                <div class="field text-center">
                    <a class="big-submit" href="#" id="exit-survey-submit">SEND</a>
                    <div class="thank-you">Thank you for your feedback.</div>
                </div>
            </form>
        </div>
        <div class="over-capacity-warning text-center" style="display: none;">
            <a class="close-overlay" href="#" rel="over-capacity-warning">
                <img src="/assets/close-overlay.png" alt="Close overlay">
            </a>
            <h2 class="text-center">Max Capacity Warning</h2>
            <div class="row">
                <div class="col-md-12">
                    <div class="text">
                        Our builders need to wait on their skill cooldowns so we can't take your order
                        right now. We want to make sure they are ready to forge your build so why don't
                        you create an account to save it then we can holler when their cooldowns are up?
                    </div>
                    <a class="button" href="#" id="queue-build">Let me save it!</a>
                    <div class="thank-you">Thank you for signing up.</div>
                    <div class="thank-you">Please look for an email from us!</div>
                    <div class="already-in-queue">You are already in the queue.</div>
                    <div class="already-in-queue">
                        Rest assured that we will contact you when it's your turn to checkout!
                    </div>
                    <a class="button" href="#" id="close-warning">Not yet!</a>
                </div>
            </div>
        </div>
        <div id="general-overlay" class="overlay" style="display:none;"></div>
        <div class="container pos-r">
            <a
                alt="Back"
                class="back-step"
                title="Back"
                data-link="step1"
                style="display: none;">
                    <i aria-hidden="true" class="back-step-ico">
                      <img src="/images/icons/back-ico.svg" alt="" width="30">
                    </i>
            </a>
        </div>
        <div class="modal fade" id="fools-modal" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-sm" role="document">
                <div class="modal-content">
                    <div class="modal-header text-center">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        <h2 class="text-white">April Fools!</h2>
                    </div>
                    <div class="modal-body text-white text-center">
                        <p>
                            Get a free Puck (Black) with every order placed on 4/1. No promotion code necessary.
                        </p>
                        <p>
                            <span class="input-group-btn m-l-fix">
                                <button
                                    @click="foolsDone()"
                                    class="btn btn-green btn-outline">
                                    CONTINUE
                                </button>
                            </span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import partdetailsModal from './part-details-modal.vue'

export default {
    name: 'StoreBldAf',
    data() {
        return {
            managingSelectedGames: false,
            games: [],
            gameSearchForm: {
                showQuestion: true,
                showInput: false,
                showThanks: false
            },
            gameSuggestion: '',
            selectedGames: [],
            gameLimit: 3,
            switchValue: "",
            resolutionFilter: '1080',
            buildIntro: true,
            partDetails: {
                show: false,
                id: null,
                variantId: null,
            },
        };
    },

    mounted() {
        // Switchery
        var elem = document.querySelector('.js-switch');
        var init = new Switchery(elem, {
            color: '#fff',
            secondaryColor: '#fff'
        });

        $(document).on('click', '.part-details', function(event) {
            event.stopPropagation();
            let btn = $(this).closest(".item").find('.btn')[0];
            let sel = $(btn).prev();
            let data = {};
            data.id = Number($(btn).attr('data-pid'));
            data.variantId = Number($(btn).attr('data-variant'));

            // Check if the button has a SELECT before it.
            if ($(sel).prop('tagName') == 'SELECT') {
                // Check that the button is selected.
                if ($(btn).hasClass('selected')) {
                    // Check if the SELECT has `data-variant`
                    if ($(sel).data('variant')) {
                        data.variantId = Number($(sel).data('variant'));
                    } else {
                        data.variantId = Number($(sel).children(':selected').val());
                    }
                } else {
                    // Check if the SELECT has `data-variant`
                    if (!data.variantId) {
                        data.variantId = Number($(btn).data('first-variant'));
                    }
                }
            }

            window.EventBus.$emit("part-details-clicked", data);
        });

        EventBus.$on("part-details-clicked", data => {
            this.partDetails.id = data.id;
            this.partDetails.variantId = data.variantId;
            this.partDetails.show = true;
            $('#parts-details-modal').modal("show");
        });

        $('#parts-details-modal').on('hidden.bs.modal', (e) => {
            // Hide all modals
            $('.modal').modal('hide');
            this.partDetails.id = null;
            this.partDetails.variantId = null;
            this.partDetails.show = false;
        })
    },
    created() {
        axios({
            url: '/games?q=(is_deleted:0)&sort=name|ASC',
            method: 'GET',
            responseType: 'json'
        }).then(response => {
            this.games = [[{
                id: 1,
                name: 'Black Hole Pinball',
                image_url: 'black-hole-pinball.jpg',
                standard_fps_1080: 60,
                standard_fps_1440: 60
            }, {
                id: 2,
                name: 'Chip\'s Challenge',
                image_url: 'chips-challenge.png',
                standard_fps_1080: 60,
                standard_fps_1440: 60
            }, {
                id: 3,
                name: 'Deus Ex',
                image_url: 'deus-ex.jpg',
                standard_fps_1080: 60,
                standard_fps_1440: 60
            }, {
                id: 4,
                name: 'Diablo',
                image_url: 'diablo.jpg',
                standard_fps_1080: 60,
                standard_fps_1440: 60
            }, {
                id: 5,
                name: 'Doom',
                image_url: 'doom.jpg',
                standard_fps_1080: 60,
                standard_fps_1440: 60
            }, {
                id: 6,
                name: 'Duke Nukem 3D',
                image_url: 'duke-nukem-3d.png',
                standard_fps_1080: 60,
                standard_fps_1440: 60
            }, {
                id: 7,
                name: 'Free Cell',
                image_url: 'free-cell.png',
                standard_fps_1080: 60,
                standard_fps_1440: 60
            }], [{
                id: 8,
                name: 'Jezz Ball',
                image_url: 'jezz-ball.png',
                standard_fps_1080: 60,
                standard_fps_1440: 60
            }, {
                id: 9,
                name: 'Microsoft Mahjong',
                image_url: 'microsoft-mahjong.jpg',
                standard_fps_1080: 60,
                standard_fps_1440: 60
            }, {
                id: 10,
                name: 'Minesweeper',
                image_url: 'minesweeper.png',
                standard_fps_1080: 60,
                standard_fps_1440: 60
            }, {
                id: 11,
                name: 'Myst',
                image_url: 'myst.png',
                standard_fps_1080: 60,
                standard_fps_1440: 60
            }, {
                id: 12,
                name: 'Pipe Dream',
                image_url: 'pipe-dream.gif',
                standard_fps_1080: 60,
                standard_fps_1440: 60
            }, {
                id: 13,
                name: 'Quake',
                image_url: 'quake.jpg',
                standard_fps_1080: 60,
                standard_fps_1440: 60
            }, {
                id: 14,
                name: 'Rodent\'s Revenge',
                image_url: 'rodents-revenge.png',
                standard_fps_1080: 60,
                standard_fps_1440: 60
            }], [{
                id: 15,
                name: 'Sid Meier\'s Alpha Centauri',
                image_url: 'sid-meiers-alpha-centauri.jpg',
                standard_fps_1080: 60,
                standard_fps_1440: 60
            }, {
                id: 16,
                name: 'Ski Free',
                image_url: 'ski-free.gif',
                standard_fps_1080: 60,
                standard_fps_1440: 60
            }, {
                id: 17,
                name: 'Solitaire',
                image_url: 'solitaire.jpg',
                standard_fps_1080: 60,
                standard_fps_1440: 60
            }, {
                id: 18,
                name: 'Starcraft',
                image_url: 'starcraft.jpg',
                standard_fps_1080: 60,
                standard_fps_1440: 60
            }, {
                id: 19,
                name: 'Syndicate',
                image_url: 'syndicate.jpg',
                standard_fps_1080: 60,
                standard_fps_1440: 60
            }, {
                id: 20,
                name: 'The Longest Journey',
                image_url: 'the-longest-journey.jpg',
                standard_fps_1080: 60,
                standard_fps_1440: 60
            }, {
                id: 21,
                name: 'Wolfenstein 3D',
                image_url: 'wolfenstein-3d.jpg',
                standard_fps_1080: 60,
                standard_fps_1440: 60
            }]];
        });
        $('body').addClass("bg-black");
    },
    updated() {
        if (!this.managingSelectedGames) {
            $('.intro').css({
                display: 'flex'
            });
            this.managingSelectedGames = true;
        }

        if (!window.nzxt_init) {
            window.nzxt_init = true;
        }
    },
    watch: {
        selectedGames: function() {
            if (this.selectedGames.length <= this.gameLimit) {
                $(".border-warning").removeClass("border-warning");
            }
        }
    },
    methods: {
        addSelectedGame(game) {
            this.managingSelectedGames = true;
            if (this.selectedGames.includes(game)) {
                this.selectedGames.splice(this.searchElementInArray(this.selectedGames, game), 1);
            } else if (!this.selectedGames.includes(game) &&
                !this.getImageClass(game, 'v-game', 'disabled-link v-game').includes("disabled-link")) {
                this.selectedGames.push(game);
            }
        },
        removeSelectedGames() {
            for (let i = 0; i <= this.selectedGames.length; i++) {
                if (this.selectedGames[i] &&
                    this.getImageClass(this.selectedGames[i], 'v-game', 'disabled-link v-game')
                    .includes("disabled-link")) {
                    this.selectedGames.splice(this.searchElementInArray(this.selectedGames, this.selectedGames[i]), 1);
                }
            }

            if (this.selectedGames.length >= this.gameLimit) {
                $(".border-warning .not-rs").removeClass("border-warning");
            }
        },
        getImageClass(game, defaultClass, newClass) {
            if (this.resolutionFilter == '1080' && Number(game.standard_fps_1080) > 0) {
                return defaultClass;
            } else if (this.resolutionFilter == '1440' && Number(game.standard_fps_1440) > 0) {
                return defaultClass;
            } else {
                return newClass;
            }
        },
        searchElementInArray(array, value) {
            for (let i = 0; i <= array.length; i++) {
                if (array[i] == value) {
                    return i;
                    break;
                }
            }
            return -1;
        },
        toggleChange(evt) {
            if (evt.target.checked) {
                this.resolutionFilter = '1440';
            } else {
                this.resolutionFilter = '1080';
            }
            this.removeSelectedGames();
        },
        processClick(evt) {
            if (this.selectedGames.length + 1 > this.gameLimit &&
                evt.target.className.includes("game_no_selected") &&
                !evt.target.className.includes("border-warning")) {
                evt.target.className += " border-warning";
            } else {
                evt.target.className = evt.target.className.replace("border-warning", "");
            }
        },
        sendGameSuggestion() {
            let data = new FormData();
            data.append('name', this.gameSuggestion);

            axios.post('games-suggestions', data).then((response) => {
                this.gameSuggestion = '';
                this.gameSearchForm.showThanks = true;
                this.gameSearchForm.showInput = false;
            });
        },
        goToSavedBuilds() {
            // User is logged in
            if (!Cookies.get("cookies_id")) {
                $('#log-in-modal').modal("show");
                this.$router.push({ query: Object.assign({}, this.$route.query, { redirect: '/user/account?currentTab=saved-build' }) });
            } else {
                this.$router.push({ name: 'UserAccount', query: { currentTab: 'saved-build'}})
            }
        },
        foolsModal() {
            $('#fools-modal').modal('show');
        },
        foolsDone() {
            $('#fools-modal').modal('hide');
            EventBus.$emit('april-fools');
            localStorage.setItem('alreadyFooled', true);
            this.$router.push({ name: 'step1'});
        }
    },
    beforeRouteUpdate (to, from, next) {
        if(to.fullPath.includes("draft")) {
            let draftUrl = to.hash;
            window.sessionStorage.setItem('draft', draftUrl);
        }
        next();
    },
    components: {
        partdetailsModal
    }
}
</script>

<style scoped lang="scss">
@import '~@s/_asset-mixers.scss';
.nzxtcustom .game-submit .fools-link a {
	width: auto;
	margin: 0 auto;
	text-align: center;
	text-transform: uppercase;
	border: 5px solid $purple;
	color: $purple;
	padding: 8px;
	font-size: 18px;
	letter-spacing: normal;
}
</style>
